// src/pages/admin/AdminLayout.tsx
import { Outlet, NavLink } from 'react-router-dom';

export default function AdminLayout() {
  const links = [
    { to: '', label: 'Unverified' },
    { to: 'ingredients/missing-conversion', label: 'Missing Units' },
    { to: 'moderation/reviews', label: 'Reviews' },
    { to: 'moderation/recipes', label: 'Recipes' },
    { to: 'reports', label: 'Reports' },
    { to: 'feedback', label: 'Feedback' }, 
  ];
  return (
    <div className="flex h-screen pt-10">
      <nav className="w-56 bg-gray-100 p-4">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            className={({ isActive }) =>
              `block mb-2 p-2 rounded ${isActive ? 'bg-gray-300' : ''}`
            }
          >
            {l.label}
          </NavLink>
        ))}
      </nav>
      <main className="flex-1 overflow-y-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}
